// Dawn's add response contains line items, while quantity/removal responses contain
// a full cart. Share a single fetch for partial responses across block instances.
(() => {
  let pendingCart;
  let latestCart;
  let revision = 0;
  let initialized = false;
  const getCart = () => {
    if (!pendingCart) {
      pendingCart = fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('Cart unavailable');
          return response.json();
        })
        .finally(() => { pendingCart = undefined; });
    }
    return pendingCart;
  };

  class FADeliveryThreshold extends HTMLElement {
    connectedCallback() {
      if (latestCart) this.render(latestCart);
      if (!initialized) {
        initialized = true;
        subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (document.querySelector('fa-delivery-threshold')) return this.updateCart(event.cartData);
          latestCart = undefined;
        });
        this.updateCart();
      } else if (!latestCart && !pendingCart) {
        this.updateCart();
      }
    }

    async updateCart(cart) {
      const currentRevision = ++revision;
      // Hide an outdated claim while refreshing; retain the ordinary delivery row.
      document.querySelectorAll('fa-delivery-threshold').forEach((element) => { element.hidden = true; });
      try {
        if (!Number.isSafeInteger(cart?.total_price) || !cart.currency) {
          // If another mutation arrives during a fetch, fetch again after it settles.
          if (pendingCart) await pendingCart;
          if (currentRevision !== revision) return;
          cart = await getCart();
        }
        if (currentRevision !== revision) return;
        latestCart = cart;
        document.querySelectorAll('fa-delivery-threshold').forEach((element) => element.render(cart));
      } catch {
        // A later cart event can recover. Do not leave a stale qualification visible.
      }
    }

    render(cart) {
      const threshold = Number(this.dataset.threshold);
      if ((this.dataset.context === 'cart' && cart.item_count === 0) || cart.currency !== this.dataset.currency || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0) {
        this.hidden = true;
        return;
      }
      const remaining = Math.max(0, threshold - cart.total_price);
      const message = this.querySelector('[data-message]');
      const emphasis = document.createElement('strong');
      if (remaining > 0) {
        const amount = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: cart.currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
        }).format(remaining / 100);
        if (this.dataset.context === 'cart') {
          emphasis.textContent = amount;
          message.replaceChildren(document.createTextNode('Add '), emphasis, document.createTextNode(' for free local delivery.'));
        } else {
          emphasis.textContent = `${amount} away from free local delivery.`;
          message.replaceChildren(document.createTextNode("You're "), emphasis);
        }
      } else {
        emphasis.textContent = this.dataset.context === 'cart' ? "Free local delivery minimum reached." : "You've qualified for free local delivery!";
        message.replaceChildren(emphasis);
      }
      const smallOrderFee = Number(this.dataset.smallOrderFee);
      if (remaining > 0 && Number.isSafeInteger(smallOrderFee) && smallOrderFee > 0) {
        const fee = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency', currency: cart.currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
        }).format(smallOrderFee / 100);
        message.prepend(document.createTextNode(`${fee} flat-rate local delivery. `));
      }
      this.hidden = false;
    }
  }
  if (!customElements.get('fa-delivery-threshold')) customElements.define('fa-delivery-threshold', FADeliveryThreshold);
})();
